export const nbsp = '\u00a0';
export const nnbsp = '\u202f';
export const shy = '\u00ad';
